import { render } from "./region-select.vue?vue&type=template&id=155b5448"
import script from "./region-select.vue?vue&type=script&lang=js"
export * from "./region-select.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__